import React, { FC } from 'react';
import { useTranslation } from '@blocs.i18n';
import { Link, NavLink } from 'react-router-dom';
import SCREEN_NAMES from 'config/constants/screenNames';
import { MenuItemMobile } from 'components/core/NavLoggedIn/Styles';

interface MobileMenuWithoutCurrentArtistProps {
  accountSettingsLink: string;
  notificationLink: { to: string };
}

const MobileMenuWithOutCurrentArtist: FC<MobileMenuWithoutCurrentArtistProps> = ({
  accountSettingsLink,
  notificationLink,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {' '}
      <MenuItemMobile component="span">
        <Link data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-account-settings`} to={accountSettingsLink}>
          {t('common:accountSettingsMenu.accountSettingsNoMark')}
        </Link>
      </MenuItemMobile>
      <MenuItemMobile component="span">
        <NavLink
          {...notificationLink}
          data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-notification-settings`}
          role="button"
        >
          {t('common:accountSettingsMenu.notificationSettings')}
        </NavLink>
      </MenuItemMobile>
    </>
  );
};

export default MobileMenuWithOutCurrentArtist;
